import React from 'react';
import { useParams } from 'react-router-dom';
import FailureScreen from 'src/frontend-common/components/FailureScreen';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';

import { UserForm } from 'src/pages/User/components/UserForm';
import { useGetUserAdminQuery } from 'src/redux/services/usersAdmin';
import { styled } from '@mui/material';

export const CustomLoadingScreen = styled(LoadingScreen)(({ theme }) => ({
  minHeight: '500px',
  backgroundColor: theme.palette.background.paper,
}));

export const UserPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isError } = useGetUserAdminQuery(id || '', {
    skip: id === 'new',
  });

  return (
    <>
      {isError && <FailureScreen>there was an error when fetching the user data! Please try refreshing the page.</FailureScreen>}
      {isLoading && <CustomLoadingScreen variant="circle" />}
      {id === 'new' && <UserForm />}
      {data && <UserForm userData={data} />}
    </>
  );
};
